import { render } from "./Course.vue?vue&type=template&id=db2658e6&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=db2658e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db2658e6"

export default script